import script from "./UsersRegistration.vue?vue&type=script&setup=true&lang=ts"
export * from "./UsersRegistration.vue?vue&type=script&setup=true&lang=ts"

import "./UsersRegistration.vue?vue&type=style&index=0&id=e51be744&scoped=true&lang=css"
script.__scopeId = "data-v-e51be744"

export default script